const BYTES_IN_KB = 1024;
const BYTES_IN_MB = 1048576;
export function getFileSize(number) {
  if (number < BYTES_IN_KB) {
    return `${number} bytes`;
  } else if (number >= BYTES_IN_KB && number < BYTES_IN_MB) {
    return `${(number / BYTES_IN_KB).toFixed(1)} KB`;
  } else if (number >= BYTES_IN_MB) {
    return `${(number / BYTES_IN_MB).toFixed(1)} MB`;
  }
  return null;
}